<template>
    <div class="col-12">
      <div class="modal-custom" v-show="showOverlay">
        <div class="loader-img-center">
          <i class="fa fa-spinner fa-spin"></i> Please wait...
        </div>
      </div>
      <div class="search-padd">
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading private_tasklist_heading_1 text-align-left">Task List</div>
          <div class="crm_admin_heading private_tasklist_heading_2 text-align-left">Status</div>
          <div class="crm_admin_heading private_tasklist_heading_3 text-align-left">Created By</div>
          <div class="crm_admin_heading private_tasklist_heading_4 text-align-left">&nbsp;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="privateLoading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div class="tasklists-row" v-for="(tasklist, index) in private_task_lists">
          <div class="crm_admin_field_lists private_tasklist_heading_1 text-align-left">
            <div class="search-padd">
              {{tasklist.name}}
            </div>
          </div>
          <div class="crm_admin_field_lists private_tasklist_heading_2 text-align-left">
            <div class="search-padd">
              {{getStatus(tasklist.status)}}
            </div>
          </div>
          <div class="crm_admin_field_lists private_tasklist_heading_3 text-align-left">
            <div class="search-padd">
              {{tasklist.created_by}}
            </div>
          </div>
          <div class="crm_admin_field_lists private_tasklist_heading_4 text-align-left">
            <div class="search-padd">
              <div v-bind:id="'dropdown-container-private'+ index" class="dropdown" @click="toggleDropdown('actionPrivateDropdown'+index+'')">
                <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu-private' + index">
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
                <div v-bind:id="'actionPrivateDropdown' + index" class="dropdown-content-private">
                  <div class="action-dd-menu" v-if="(tasklist.masteradmin == true)" @click="goToEdit(tasklist.id)"><i class="cursor-pointer fa fa-edit spacer-icon"></i>Edit</div>
                  <div class="action-dd-menu" v-if="(tasklist.status=='DRAFT'  && tasklist.masteradmin == true)" @click="updateTasklistStatus(tasklist.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                  <div class="action-dd-menu"  v-if="(tasklist.status=='DRAFT' && tasklist.masteradmin == true)" @click="deleteTaskListConfirm(tasklist.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                  <div class="action-dd-menu"  v-if="(tasklist.status=='PUBLISH' && tasklist.masteradmin == true)" @click="cloneTasklist(tasklist.id)"><i class="cursor-pointer fa fa-clone spacer-icon"></i>Clone</div>
                  <div class="action-dd-menu" v-if="(tasklist.status=='PUBLISH'  && tasklist.masteradmin == true)" @click="deactivateTaskListConfirm(tasklist.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                  <div class="action-dd-menu" @click="previewTaskList(tasklist.id)"><i class="cursor-pointer fa fa-eye spacer-icon"></i>Preview</div>
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="tasklist-item-seperator"></div>

        </div>
        <div class="col-12 override-padding" v-if="private_task_lists.length == 0 && privateLoading == false">
          No task lists found
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
      </div>


      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to delete the task list?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteTasklist(id)">Confirm</button>
        </div>
      </DeleteModal>

      <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to deactivate?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateTasklist(deactivateId)">Confirm</button>
        </div>
      </DeactivateModal>

    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';

export default {
      props: ['accountId'],
      data() {
        return {
          account_tasklists: [],
          loading: false,
          privateLoading: false,
          showOverlay: false,
          id: '',
          deactivateId: '',
          private_task_lists: [],
          isDeleteModalVisible: false,
          isDeactivateModalVisible: false,
          status_options: [
            { value: '', text: 'Status' },
            { value: 'DRAFT', text: 'Draft' },
            { value: 'PUBLISH', text: 'Published' },
            { value: 'DEACTIVATED', text: 'Deactivated' }
          ],
          showOverlay: false,
        }
      },
      components: {
        DeleteModal,
        DeactivateModal,
      },
      methods: {
        fetchPrivateTasklistitems() {
          this.privateLoading = true;
          const params = {};
          params.no_page = 'true';
          params.account_id = this.accountId;
          axios.get('/private_tasklists', {
             params: params
          })
          .then((resp) => {
              this.privateLoading = false;
              this.private_task_lists = resp.data.data;
          })
          .catch(error => {

          });
        },
        toggleDropdown (id) {
            document.getElementById(id).classList.toggle("show");
        },
        goToEdit(id) {
           store.dispatch('subtasks', '');
           let page_url = this.$route.fullPath;
            let active_tab = 'PathwayTab';
            let active_sub_tab = 'PrivateTasklistsTab';
            this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
           let title = 'Edit';
           store.dispatch('tasklist_title', { title })
           router.push("/create-sub-tasklists/" + id);
        },
        updateTasklistStatus(tasklist_id, status_text) {
          this.showOverlay = true;
          axios('/tasklist/' + tasklist_id,
           {
             method: 'PATCH',
             data: { "status": status_text},
           }
          )
          .then((resp) => {
            this.showOverlay = false;
            this.fetchPrivateTasklistitems();
            this.$parent.getalltasklists();
          })
          .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
          });
       },
       cloneTasklist(tasklist_id) {
         this.showOverlay = true;
         axios('/clone-tasklist/' + tasklist_id,
          {
            method: 'POST',
            data: {account_id: this.accountId},
          }
         )
         .then((resp) => {
           this.showOverlay = false;
           let page_url = this.$route.fullPath;
            let active_tab = 'PathwayTab';
            let active_sub_tab = 'PrivateTasklistsTab';
            this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
           store.dispatch('subtasks', '');
           router.push("/create-sub-tasklists/" + resp.data);
         })
         .catch(error => {
              console.log(error.response);
             if((error) && (error.response.data.message == 'Access denied.')) {
               router.push("/forbidden");
             }
         });
       },
       deactivateTaskListConfirm(tasklist_id) {
         this.isDeactivateModalVisible = true;
         this.deactivateId = tasklist_id;
       },
       deactivateTasklist(tasklist_id) {
         this.isDeactivateModalVisible = false;
         this.showOverlay = true;
         axios('/tasklist/' + tasklist_id,
          {
            method: 'PATCH',
            data: { "status": 'DEACTIVATED'},
          }
         )
         .then((resp) => {
           this.showOverlay = false;
           this.fetchPrivateTasklistitems();
         })
         .catch(error => {
             if(error.response.data.message == 'Access denied.') {
               router.push("/forbidden");
             }
         });
       },
       hidePrivateActionMenu(e) {
          var matches = document.getElementsByClassName('dropdown-content-private');
          for (var i=0; i<matches.length; i++) {
            var container = document.getElementById('dropdown-container-private'+ i);

            if (!container.contains(e.target)) {
                 if (document.getElementById('actionPrivateDropdown' + i).classList.contains("show")) {
                    document.getElementById('actionPrivateDropdown' + i).classList.remove('show');
                 }
            }
          }
        },
        getStatus: function(status) {
          var status_val = this.status_options.findIndex(item => item.value === status);
          return this.status_options[status_val].text;
        },
        deleteTaskListConfirm: function(tasklist_id) {
          this.isDeleteModalVisible = true;
          this.id = tasklist_id;
        },
        deleteTasklist: function(tasklist_id) {
          this.isDeleteModalVisible = false;
          this.showOverlay = true;
          axios('/tasklist/' + tasklist_id,
             {
               method: 'DELETE',
             }
           )
          .then((resp) => {
              this.showOverlay = false;
              this.fetchPrivateTasklistitems();
           })
          .catch(error => {

          });
        },
        previewTaskList(tasklist_id) {
                    let page_url = this.$route.fullPath;
                    let active_tab = 'PathwayTab';
                    let active_sub_tab = 'PrivateTasklistsTab';
                    this.$store.dispatch('active_tab', { page_url, active_tab, active_sub_tab })
           router.push("/tasklist-preview/"+tasklist_id);
        },

      },
      mounted() {
         document.addEventListener('click', this.hidePrivateActionMenu);
      },
      beforeDestroy() {
         document.removeEventListener('click', this.hidePrivateActionMenu);
      },
      created: function () {
        this.fetchPrivateTasklistitems();
      },
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_private_tasklists_tab.vue